/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import {
  HeadingContainer, StatsGraphHeading, NoResultsHeading, LoadingSpinner,
} from '../Styles';
import DateFilterDropdown from '../DateFilterDropdown';
import PieChartGraph from '../PieChart';

import useStrings from '../../../../hooks/useStrings';
import { useGetTopLocationsBySuburb } from '../../../../lib/graphql/queries';
import { fromDate } from '../../../../lib/Utils';

const TopLocationsSuburb: React.FC<TopLocationsSuburbProps> = () => {
  const [{ Statistics: strings }] = useStrings();

  const [showDateFilter, setShowDateFilter] = useState(false);
  const [filterSelected, setFilterSelected] = useState<'week' | 'month' | 'year'>('week');

  const { data: topLocationsSuburbData, loading } = useGetTopLocationsBySuburb({
    variables: { fromDate: fromDate(filterSelected) },
  });
  const topLocationsSuburb = topLocationsSuburbData?.topLocationsBySuburb.locations?.map((type) => (
    {
      name: type.suburb,
      value: type.count,
    }
  )) || [];

  return (
    <>
      <HeadingContainer>
        <StatsGraphHeading>{strings.topEventLocations}</StatsGraphHeading>
        <DateFilterDropdown
          onToggleDropdown={() => setShowDateFilter(!showDateFilter)}
          isDropdownShown={showDateFilter}
          onClickFilter={setFilterSelected}
          filterSelected={filterSelected}
        />
      </HeadingContainer>
      {loading
        ? <LoadingSpinner />
        : topLocationsSuburb.length === 0
          ? <NoResultsHeading>{strings.noResults}</NoResultsHeading>
          : <PieChartGraph data={topLocationsSuburb} />}
    </>
  );
};

interface TopLocationsSuburbProps { }

export default TopLocationsSuburb;
